/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Settings_Toggle_Product_ImprovementInputs */

const en_consent_settings_toggle_product_improvement = /** @type {(inputs: Consent_Settings_Toggle_Product_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product improvement data`)
};

const de_consent_settings_toggle_product_improvement = /** @type {(inputs: Consent_Settings_Toggle_Product_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktverbesserungsdaten`)
};

const fr_consent_settings_toggle_product_improvement = /** @type {(inputs: Consent_Settings_Toggle_Product_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donnees d'amelioration du produit`)
};

const es_consent_settings_toggle_product_improvement = /** @type {(inputs: Consent_Settings_Toggle_Product_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de mejora del producto`)
};

const it_consent_settings_toggle_product_improvement = /** @type {(inputs: Consent_Settings_Toggle_Product_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati di miglioramento del prodotto`)
};

const nl_consent_settings_toggle_product_improvement = /** @type {(inputs: Consent_Settings_Toggle_Product_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productverbeteringsgegevens`)
};

const pl_consent_settings_toggle_product_improvement = /** @type {(inputs: Consent_Settings_Toggle_Product_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane ulepszania produktu`)
};

const fi_consent_settings_toggle_product_improvement = /** @type {(inputs: Consent_Settings_Toggle_Product_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuoteparannustiedot`)
};

const da_consent_settings_toggle_product_improvement = /** @type {(inputs: Consent_Settings_Toggle_Product_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktforbedringsdata`)
};

const sv_consent_settings_toggle_product_improvement = /** @type {(inputs: Consent_Settings_Toggle_Product_ImprovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktforrattringsdata`)
};

/**
* | output |
* | --- |
* | "Product improvement data" |
*
* @param {Consent_Settings_Toggle_Product_ImprovementInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_settings_toggle_product_improvement = /** @type {((inputs?: Consent_Settings_Toggle_Product_ImprovementInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Settings_Toggle_Product_ImprovementInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_settings_toggle_product_improvement(inputs)
	if (locale === "fr") return fr_consent_settings_toggle_product_improvement(inputs)
	if (locale === "es") return es_consent_settings_toggle_product_improvement(inputs)
	if (locale === "it") return it_consent_settings_toggle_product_improvement(inputs)
	if (locale === "nl") return nl_consent_settings_toggle_product_improvement(inputs)
	if (locale === "pl") return pl_consent_settings_toggle_product_improvement(inputs)
	if (locale === "fi") return fi_consent_settings_toggle_product_improvement(inputs)
	if (locale === "da") return da_consent_settings_toggle_product_improvement(inputs)
	if (locale === "sv") return sv_consent_settings_toggle_product_improvement(inputs)
	return en_consent_settings_toggle_product_improvement(inputs)
});